var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell space-1 small-12 medium-4 text-left space-left space-right"},[_c('h3',[_vm._v("❱ "+_vm._s(_vm.topic))]),_c('hr'),_c('p',{staticClass:"no-padding"},[_vm._v(_vm._s(_vm.explain))])])}
var staticRenderFns = []

export { render, staticRenderFns }